document.addEventListener('DOMContentLoaded', function () {
	// Cart drawer trigger
	const triggerBtn = document.getElementById('cart-drawer-button-section');
	if (triggerBtn) {
		triggerBtn.addEventListener('click', function () {
			const cartDrawer = document.querySelector('cart-drawer-component');
			if (!cartDrawer) return;

			const openButton = cartDrawer.querySelector('button[on\\:click="/open"]');
			if (openButton) {
				openButton.click();
			}
		});
	}

	// Accordion
	const accordions = document.querySelectorAll('.accordion');
	accordions.forEach(function (accordion) {
		const header = accordion.querySelector('[data-accordion-action]');
		const content = accordion.querySelector('[data-accordion-target]');
		const icon = header ? header.querySelector('[data-accordion-icon]') : null;

		if (!header || !content) return;

		header.addEventListener('click', function () {
			const isHidden = content.style.display === 'none' || content.style.display === '';
			content.style.display = isHidden ? 'flex' : 'none';

			if (icon) {
				icon.classList.toggle('rotate', isHidden);
			}
		});
	});

	// Move inventory status badge into vendor+SKU row
	var vendorSku = document.querySelector('.product-vendor-sku');
	var inventory = document.querySelector('.product-details product-inventory');
	if (vendorSku && inventory) {
		var statusSpan = inventory.querySelector('.product-inventory__status');
		if (statusSpan) {
			vendorSku.appendChild(statusSpan.cloneNode(true));
			inventory.classList.add('moved-to-vendor-sku');
		}
	}

	// Search is now handled by cpap-search.js
});

// Facet clear button delegation
document.addEventListener('click', function (e) {
	const btn = e.target.closest('.btn-clear');
	if (!btn) return;

	e.preventDefault();

	const clearBtn = document.querySelector('.facets__clear-all-link.facets__clear-all.active');
	if (clearBtn) {
		clearBtn.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
	}
});

// Variant SKU sync for the default (stock-Horizon) product template.
// The default PDP prints SKU in a static custom-liquid block ('.product-sku')
// that no component refreshes. The variant-picker re-fetches the section on
// change and dispatches a bubbling `variant:update` carrying the re-rendered
// HTML, so pull the new SKU from it. Scoped to the dispatching section so
// related-product cards elsewhere on the page are never touched.
// (Custom mask/part/machine PDPs update their own SKU inline — see those sections.)
document.addEventListener('variant:update', function (event) {
	try {
		const detail = event.detail || {};
		const newHtml = detail.data && detail.data.html;
		if (!newHtml) return;
		const section = event.target && event.target.closest && event.target.closest('.shopify-section');
		if (!section) return;
		const current = section.querySelector('.product-sku');
		const incoming = newHtml.querySelector('.product-sku');
		if (current && incoming && current.textContent !== incoming.textContent) {
			current.textContent = incoming.textContent;
		}
	} catch (e) {}
});
